// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeOutlinedSvg from "@fishx/icons-svg/es/asn/CodeOutlined";
import FishxIcon from '../components/FishxIcon';

var CodeOutlined = function CodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeOutlinedSvg
  }));
};

CodeOutlined.displayName = 'CodeOutlined';
export default React.forwardRef(CodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodeOutlined.js
// module id = 2263
// module chunks = 0